import { render, staticRenderFns } from "./RootFabbricatiIdStanzeIdView.vue?vue&type=template&id=70ac03ae&"
import script from "./RootFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"
export * from "./RootFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports